export interface AdminRequest {
  ticketId: string;
  ticketCreationDatetime: string;
  ticketClosureDatetime: string;
  resolutionTime: string;
  type: string;
  subType: string;
  description: string;
  resonPurpose: string;
  closureCode: string;
  priority: string;
  status: string;
  createdBy: string;
  closedBy: string;
  foruserid: number[];
}

export const initialAdminRequest: AdminRequest = {
  ticketId: "",
  ticketCreationDatetime: "",
  ticketClosureDatetime: "",
  foruserid: [],
  resolutionTime: "",
  type: "",
  subType: "",
  description: "",
  resonPurpose: "",
  closureCode: "",
  priority: "",
  status: "",
  createdBy: "",
  closedBy: "",
};
